// New login dialog component for production login
import { supabase } from "luminicad-core";
import { button, div, input } from "./index";
import style from "./login-dialog.module.css";

export function LoginDialog(props: { onSuccess: () => void }) {
    const overlay = div({ className: style.overlay });
    const dialog = div({ className: style.dialog });

    const header = div(
        { className: style.header },
        div({ className: style.title, textContent: "Welcome back" }),
        div({ className: style.subtitle, textContent: "Sign in to sync your documents" }),
    );

    const form = div(
        { className: style.form },
        input({
            className: style.input,
            type: "email",
            placeholder: "Email address",
            autocomplete: "email",
        }),
        input({
            className: style.input,
            type: "password",
            placeholder: "Password",
            autocomplete: "current-password",
        }),
    );

    const statusLine = div({ className: style.status });

    async function handleEmailLogin() {
        const emailInput = form.children[0] as HTMLInputElement;
        const passwordInput = form.children[1] as HTMLInputElement;

        statusLine.textContent = "Signing in...";
        statusLine.className = style.status;

        const { error } = await supabase.auth.signInWithPassword({
            email: emailInput.value,
            password: passwordInput.value,
        });

        if (error) {
            statusLine.textContent = error.message;
        } else {
            statusLine.textContent = "Success! Redirecting...";
            statusLine.className = `${style.status} ${style.success}`;
            setTimeout(() => {
                overlay.remove();
                props.onSuccess();
            }, 1000);
        }
    }

    function handleGoogle() {
        supabase.auth.signInWithOAuth({
            provider: "google",
            options: { redirectTo: window.location.href },
        });
    }

    const buttons = div(
        { className: style.buttons },
        button({
            className: style.primaryButton,
            textContent: "Sign in",
            onclick: handleEmailLogin,
        }),
        div({ className: style.divider, textContent: "or" }),
        button({
            className: style.googleButton,
            onclick: handleGoogle,
            innerHTML: `
                <svg width="20" height="20" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M21.35 10.04C21.49 10.67 21.56 11.34 21.56 12C21.56 17.31 17.31 21.56 12 21.56C6.69 21.56 2.44 17.31 2.44 12C2.44 6.69 6.69 2.44 12 2.44C14.61 2.44 16.95 3.47 18.69 5.21L15.79 8.11C14.77 7.08 13.44 6.56 12 6.56C8.66 6.56 5.96 9.26 5.96 12C5.96 14.74 8.66 17.44 12 17.44C15.34 17.44 17.31 15.67 17.6 13.24H12V9.24H21.38C21.44 9.5 21.35 10.04 21.35 10.04Z"/>
                </svg>
                Continue with Google
            `,
        }),
        button({
            className: style.cancelButton,
            textContent: "Cancel",
            onclick: () => overlay.remove(),
        }),
    );

    dialog.append(header, form, statusLine, buttons);
    overlay.append(dialog);

    // Focus email input when dialog opens
    setTimeout(() => (form.children[0] as HTMLInputElement).focus(), 50);

    return overlay;
}
